import { useState } from "react";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { TextField, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { useMutation, useQueryClient } from "react-query";
import { sendOTPFn } from "../../Services/Authentication/SendOTP";
import { verifyOTPFn } from "../../Services/Authentication/VerifyOTP";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../Redux/Actions/SnackBar";
import { bulkAddToCartFn } from "../../Services/BulkAddToCart";
import { setCart } from "../../Redux/Actions/Cart";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { flatten } from "lodash";

export default function SignIn() {
  const [open, setOpen] = useState(false);
  const [registrationToken, setResgistrationToken] = useState("");
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [phone, setPhone] = useState("");
  const dispatch = useDispatch();
  const client = useQueryClient();

  const { mutate: sendOTP, isLoading } = useMutation(sendOTPFn, {
    onSuccess: (res) => {
      res.data.message === "OTP has been send to your mobile no.!" &&
        setOpen(true);
      dispatch(
        setSnackbar({
          open: true,
          message: res.data.message,
          variant: "info",
        })
      );
    },
  });
  const cart = useSelector((state) => state.cart);
  const dataCart = flatten(
    cart?.map((item) => [
      {
        variant_id: Number(item.item.variant_id),
        quantity: Number(item.quantity),
      },
    ])
  );
  const { mutate: bulkAddToCart } = useMutation(bulkAddToCartFn, {
    onSuccess: (res) => {
      client.refetchQueries("cartList");
      localStorage.removeItem("cart");
      dispatch(setCart([]));
    },
  });

  const { mutate: verifyOTP, isLoading: isLoadingOTP } = useMutation(
    verifyOTPFn,
    {
      onSuccess: (res) => {
        dispatch(
          setSnackbar({
            open: true,
            message: res.data.message,
            variant: "success",
          })
        );
        if (res.data.response_code === 200) {

          window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'USER_INFO',
              userId: res?.data?.user_id,
              email: res?.data?.email,
            })
          );
          localStorage.setItem("bhaarattoken", res.data.token);
          client.refetchQueries("profile");
          client.refetchQueries("cartList");
          client.refetchQueries("myWishList");
          bulkAddToCart(dataCart);
          setOpen(false);
          navigate("/profile");
        }
      },
    }
  );

  const messaging = getMessaging(
    initializeApp({
      apiKey: "AIzaSyCNELqMd97h4d-SZ7iBw-HwPuHweOId9dM",
      authDomain: "bhaarat-stores.firebaseapp.com",
      databaseURL: "https://bhaarat-stores-default-rtdb.firebaseio.com",
      projectId: "bhaarat-stores",
      storageBucket: "bhaarat-stores.appspot.com",
      messagingSenderId: "837459804001",
      appId: "1:837459804001:web:15babf4c3ce0c7a9ef0f20",
      measurementId: "G-9CQEJ7QV51",
    })
  );

  getToken(messaging, {
    vapidKey:
      "BAJou_AlaYLrFsQoZvDIWKxaz_WxVcTFQSirzOyaBGnu_khQ7JKPIsPxTrqMujSKPXeuPlmXE_nB0xw3MvAI2w4",
  })
    .then((currentToken) => {
      if (currentToken) {
        // Token is available
        setResgistrationToken(currentToken);
      } else {
        // Token is not available, request permission
        return requestNotificationPermission();
      }
    })
    .catch((error) => {
      console.log("Error getting token:", error);
    });

  const requestNotificationPermission = async () => {
    return Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");
        return getToken(messaging, {
          vapidKey:
            "BAJou_AlaYLrFsQoZvDIWKxaz_WxVcTFQSirzOyaBGnu_khQ7JKPIsPxTrqMujSKPXeuPlmXE_nB0xw3MvAI2w4",
        });
      } else {
        console.log("Notification permission denied.");
        // Handle permission denied case
      }
    });
  };

  const handleSendOTP = (event) => {
    event.preventDefault();
    sendOTP({
      mobile_number: phone,
    });
  };
  const handleVerifyOTP = (event) => {
    event.preventDefault();
    verifyOTP({
      mobile_number: phone,
      mobile_otp: otp,
      registration_token: registrationToken,
      type: "web",
      device_id: "",
      referral_code: "",
    });
  };

  return (
    <>
      <div className="px-3 py-3">
        <CloseIcon onClick={() => navigate(-1)} />
        <p className="py-5 pt-10 font-bold text-xl">Welcome !</p>
        <p className="">Enter your mobile number to start earning.</p>
      </div>

      <form
        onSubmit={(event) => otp.length !== 6 && handleSendOTP(event)}
        className="flex flex-col gap-16 justify-center px-3 !py-5"
      >
        <TextField
          type="number"
          className="!w-full"
          required
          id="number"
          name="number"
          label="Mobile Number"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
        />

        <span className="px-1">
          By continuing, I agree to the
          <span className="text-blue-700 px-1">
            Term of Use and Privacy Policy
          </span>
        </span>

        <Button
          disableElevation
          disabled={phone?.length === 10 ? false : true}
          type="submit"
          className="!w-full text-white"
          variant={isLoading ? "outlined" : "contained"}
        >
          {isLoading ? <CircularProgress size={25} /> : "Continue"}
        </Button>
      </form>
      <Drawer anchor="top" open={open}>
        <div className="px-3 py-3">
          <CloseIcon onClick={() => setOpen(false)} />
          <span className="flex pt-10">
            <p>
              Please enter the verification code we have sent you on
              <span className="font-semibold pl-1">{phone}</span>
              <span
                className="text-primary px-1 underline"
                onClick={() => setOpen(false)}
              >
                Edit
              </span>
            </p>
          </span>
        </div>

        <form
          onSubmit={handleVerifyOTP}
          className="flex flex-col justify-center gap-5 p-3 py-8"
        >
          <span className="flex flex-col items-end">
            <TextField
              value={otp}
              className="!w-full"
              label="Verification Code"
              onChange={(event) => setOtp(event.target.value)}
            />

            <Button
              variant="text"
              type="button"
              className="text-right !capitalize !underline"
              onClick={handleSendOTP}
            >
              Resend OTP
            </Button>
          </span>

          <Button
            disableElevation
            disabled={otp?.length === 6 ? false : true}
            className="!w-full text-white"
            variant={isLoadingOTP ? "outlined" : "contained"}
            type="submit"
          >
            {isLoadingOTP ? <CircularProgress size={25} /> : "Verify"}
          </Button>
        </form>
      </Drawer>
    </>
  );
}
